import { render, staticRenderFns } from "./brand-Introduction.vue?vue&type=template&id=05d169e9&scoped=true&"
import script from "./brand-Introduction.vue?vue&type=script&lang=js&"
export * from "./brand-Introduction.vue?vue&type=script&lang=js&"
import style0 from "./brand-Introduction.vue?vue&type=style&index=0&id=05d169e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d169e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d169e9')) {
      api.createRecord('05d169e9', component.options)
    } else {
      api.reload('05d169e9', component.options)
    }
    module.hot.accept("./brand-Introduction.vue?vue&type=template&id=05d169e9&scoped=true&", function () {
      api.rerender('05d169e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/brand-Introduction.vue"
export default component.exports